import { Event, EventBeddingType } from "../../models"
import { StablingAndExtrasItem, StablingAndExtrasOptionsData } from "../eventStallType/FormatStablingOptionsUtil";
import { getEventBeddingTypesByEventId } from "./EventBeddingType"

export const getFormattedStablingOptionDataForEventBedding = async (event: Event) => {
    let stablingOptionData: StablingAndExtrasOptionsData = {
        label: "Bedding",
        options: [{ value: "0", label: "No bedding options for this event", cost: "0", description: ""}]
    };

    const currentEventBeddingTypes: EventBeddingType[] = await getEventBeddingTypes(event);
    const formattedData = formatBeddingData(currentEventBeddingTypes);

    stablingOptionData.options = formattedData;

    return stablingOptionData;
}

const getEventBeddingTypes = async (event: Event) => {
    let currentEventBeddingTypes: EventBeddingType[] = [];
    const queryResult = await getEventBeddingTypesByEventId(event.id);
    if (queryResult.isSuccess) {
        currentEventBeddingTypes = queryResult.result;
    }
    return currentEventBeddingTypes;
}

const formatBeddingData = (currentEventBeddingTypes: EventBeddingType[]) => {
    const formattedData: StablingAndExtrasItem[] = [];
    for (let i = 0; i < currentEventBeddingTypes.length; i++) {
        const current = currentEventBeddingTypes[i];
        const formatted: StablingAndExtrasItem = {
            value: current.id,
            label: current.name || "Unknown Name",
            cost: current.pricePerBag || "Unknown Price",
            description: current.description || "",
            eventBeddingType: current,
            eventBeddingTypeId: current.id
        };
        formattedData.push(formatted);
    }
    const sortedData = formattedData.sort((a, b) => a.label.localeCompare(b.label));
    return sortedData;
}